module.exports = __webpack_public_path__ + "static/img/u11.4ea50e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kexie/regen/u11.png
// module id = eYrl
// module chunks = 0